import CustomFormat from "@/helpers/custom-format";
import EStatus from '@/helpers/estatus.js';

export default {
  regras: {
    valorPremioMin: function(premioMin, premioMax) {
      premioMin = CustomFormat.removeMoneyFormat(premioMin);
      premioMax = CustomFormat.removeMoneyFormat(premioMax);
      return [
        (!premioMin || premioMin == 0) ||
        (premioMin > 0 && premioMin <= premioMax) ||
        (premioMin > 0 && (!premioMax || premioMax == 0)) ||
        'Preencha um valor válido'
      ]
    },
    valorPremioMax: function(premioMin, premioMax) {
      premioMin = CustomFormat.removeMoneyFormat(premioMin);
      premioMax = CustomFormat.removeMoneyFormat(premioMax);
      return [
        (!premioMax || premioMax == 0) ||
        (premioMax > 0 && premioMin <= premioMax) ||
        (premioMax > 0 && (!premioMin || premioMin == 0)) ||
        'Preencha um valor válido'
      ]
    },
    valorPremio: function(premioMin) {
      premioMin = CustomFormat.removeMoneyFormat(premioMin);
      return [
        (premioMin > 0) ||
        'Preencha um valor válido'
      ]
    },
    valorPorcentagem: function(porcMin) {
      //porcMin = CustomFormat.removeMoneyFormat(porcMin);
      return [
        (porcMin <= 100)||
        'Valor não pode ser maior que 100%'
      ]
    },
  },
  getMapaSolicitacoesAgrupadas: function(statusList, mapaStatusCliente, mapaPermissoes) {
    if (statusList) {
      let map = new Map();
      
      statusList.forEach(status => {
        const idStatusAdequado = this.getIdStatusAdequado(status.id, mapaStatusCliente, mapaPermissoes);
        
        if (!map.get(idStatusAdequado)) {
          map.set(idStatusAdequado, []);
        }
      });
      return map;
    } else {
      return null;
    }
  },
  getMapaStatusCliente: function(mapaPermissoes) {
    if (!mapaPermissoes.get('ANALISA_SOLICITACAO')) {
      let map = new Map();

      map.set(EStatus.statusEnum.PROCESSAMENTO, EStatus.statusEnum.EM_ANALISE);
      map.set(EStatus.statusEnum.PENDENTE, EStatus.statusEnum.EM_ANALISE);
      map.set(EStatus.statusEnum.DIRECIONAMENTO_COMERCIAL, EStatus.statusEnum.DIRECIONAMENTO_COMERCIAL);
      map.set(EStatus.statusEnum.EM_ANALISE, EStatus.statusEnum.EM_ANALISE);
      map.set(EStatus.statusEnum.RESERVA_NAO_ACEITA, EStatus.statusEnum.RESERVA_NAO_ACEITA);
      map.set(EStatus.statusEnum.AGUARDANDO_CLIENTE, EStatus.statusEnum.AGUARDANDO_CLIENTE);
      map.set(EStatus.statusEnum.PROPOSTA_CONTESTADA, EStatus.statusEnum.PROPOSTA_CONTESTADA);
      map.set(EStatus.statusEnum.PROPOSTA_EXPIRADA, EStatus.statusEnum.PROPOSTA_EXPIRADA);
      map.set(EStatus.statusEnum.AGUARDANDO_EFETIVACAO, EStatus.statusEnum.AGUARDANDO_EFETIVACAO);
      map.set(EStatus.statusEnum.EFETIVANDO_PROPOSTA, EStatus.statusEnum.AGUARDANDO_EFETIVACAO);
      map.set(EStatus.statusEnum.APOLICE_EM_EMISSAO, EStatus.statusEnum.APOLICE_EM_EMISSAO);
      map.set(EStatus.statusEnum.SEGURO_REJEITADO, EStatus.statusEnum.SEGURO_REJEITADO);
      map.set(EStatus.statusEnum.ENCERRADO, EStatus.statusEnum.ENCERRADO);

      return map;
    } else {
      return null;
    }
  },
  getIdStatusAdequado: function(idStatus, mapaStatusCliente, mapaPermissoes) {
    if (mapaPermissoes.get('ANALISA_SOLICITACAO')) {
      return idStatus;
    } else if (mapaStatusCliente) {
      return mapaStatusCliente.get(idStatus);
    }
  },
}


// WEBPACK FOOTER //
// ./src/components/pages/listagem-solicitacoes/functions.js